import { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { publicRoutes, protectedRoutes } from './routes.config';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import Loader from '../components/common/Loader';

const AppRoutes = () => (
    <Suspense fallback={<Loader />}>
        <Routes>
            {publicRoutes.map(({ path, component: Component }) => (
                <Route key={path} path={path} element={<PublicRoute><Component /></PublicRoute>} />
            ))}
            {protectedRoutes.map(({ path, component: Component }) => (
                <Route key={path} path={path} element={<ProtectedRoute><Component /></ProtectedRoute>} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    </Suspense>
);

export default AppRoutes;
